import { render, staticRenderFns } from "./collapsibeText.vue?vue&type=template&id=e730d958&scoped=true"
import script from "./collapsibeText.vue?vue&type=script&lang=js"
export * from "./collapsibeText.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./collapsibeText.vue?vue&type=style&index=0&id=e730d958&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e730d958",
  "5ab2d9ad"
  
)

export default component.exports